import {
  postRequestOtp,
  postVerifyOtp,
} from '../services/api/requests/DeleteAccount'
// import { doPostLogout } from './Login'

export const doRequestOtp = async ({
  toMobile,
  accessToken,
  setDeleteRequestId,
  setDeleteMaskedData,
  setStatus = () => {},
}) => {
  try {
    setStatus({})
    const response = await postRequestOtp({ accessToken, toMobile })
    const { status, data } = response || {}
    const { requestId, maskedEmail, lastFourDigits } = data
    setDeleteRequestId(requestId)
    setDeleteMaskedData({ maskedEmail, lastFourDigits })
    return { status }
    // redirect to OTP screen
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}
    console.log('request otp failed: ', { ...error, message })

    setStatus({
      status,
      error: message,
    })
    return { status }
  }
}

export const doVerifyOtp = ({
  replace,
  accessToken,
  deleteRequestId: requestId,
}) => async (values, state) => {
  const { code } = values
  const { setStatus, setSubmitting } = state
  setStatus({})
  setSubmitting(true)

  try {
    // request validate OTP
    const response = await postVerifyOtp({ accessToken, requestId, code })
    const {
      // data,
      status,
    } = response || {}
    if (status === 200) {
      setSubmitting(false)
      replace('/delete-account/success')
    }
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}
    console.log('verify otp failed: ', { ...error, message })

    setStatus({
      status,
      error: message,
    })

    setSubmitting(false)
    return { status }
  }
}
